// extracted by mini-css-extract-plugin
export default {"popupBox":"index_popupBox_KY2V4","popup":"index_popup_jxu0i","popupPic":"index_popupPic_7Dz-6","popupQrcode":"index_popupQrcode_tmtij","popupClose":"index_popupClose_z7C4I"};